import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  fabIcon: {
    right: 30,
    position: 'fixed',
    bottom: 20,
    zIndex: 1,
    // Improve print previews and PDFs
    '@media print': {
      display: 'none',
    },
  },
  dialogRoot: {
    '& .MuiDialog-paper': {
      [theme.breakpoints.up('sm')]: {
        minWidth: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '90%',
      },
    },
  },
  infoMessage: {
    position: 'absolute',
    top: 65,
    width: '30%',
    right: 25,
    background: '#ececec',
    fontSize: 12,
    border: '1px solid #e8e8e8',
    borderRadius: 3,
    padding: 10,
    boxShadow: '1px 1px 2px #bfb0b0',
    color: '#8e8c8c',
  },
  infoIcon: {
    marginRight: 5,
    opacity: 0.3,
  },
  saveButton: {
    minWidth: '100px',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    height: '100%',
    maxWidth: '100%',
  },
  width100: {
    width: '100%',
  },
  p10: {
    padding: 10,
  },
  height100: {
    height: '100%',
  },
  formRoot: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
  },
  typography: {
    lineHeight: '1.5',
    color: 'grey',
  },
  buttonWithoutIcon: {
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
  },
  showAllButton: {
    marginLeft: theme.spacing(3),
  },
  clickable: {
    cursor: 'pointer',
  },
  tabLabel: {
    padding: theme.spacing(1.2),
    marginBottom: theme.spacing(1),
    borderBottom: '2px solid transparent',
    cursor: 'pointer',
    minWidth: 100,
    textAlign: 'center',
  },
  tabActive: {
    borderBottom: '2px solid',
    backgroundColor: '#fbfbfb',
    fontWeight: '600',
  },
  fieldIcon: {
    marginRight: 5,
    cursor: 'pointer',
  },
  searchResult: {
    position: 'absolute',
    backgroundColor: '#fff',
    padding: 5,
    borderRadius: 3,
    boxShadow: '0 1px 6px 0 rgba(32, 33, 36, 0.28)',
    zIndex: 2,
    overflowY: 'auto',
  },
  searchResultAllowCreate: {
    width: '100%',
    top: 35,
    height: 225,
  },
  resultList: {
    color: '#808080',
    minHeight: '43',
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  previewLabel: {
    width: '60%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: '600',
    color: '#000',
    marginLeft: 5,
  },
  listDivider: {
    backgroundColor: 'rgb(191 187 187 / 12%)',
  },
  resultTitle: {
    color: '#DEDEDE',
    width: '100%',
  },
  optionList: {
    color: '#808080',
    minHeight: 43,
    fontSize: 12,
    flexDirection: 'column',
  },
  resultLabel: {
    fontSize: 14,
    fontWeight: '600',
    width: '33%',
    padding: 5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  resultInfo: {
    width: '33%',
    padding: 5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  InfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
  },
  scheduleForm: {
    '& .MuiGrid-grid-xs-true': {
      padding: 2,
    },
    '& .MuiGrid-spacing-xs-3': {
      margin: 'unset',
    },
  },
  tableRoot: {
    '& .MuiTableCell-root': {
      borderBottom: 0,
    },
    '& .MuiTableCell-head': {
      borderBottom: '1px solid rgba(224, 224, 224)',
    },
  },
  selectRoot: {
    width: 500,
  },
  listLabel: {
    fontWeight: '600',
    color: '#000',
    marginTop: 20,
  },
  hideHelperText: {
    '& .MuiFormHelperText-contained': {
      display: 'none',
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },
  multilineVehicleLabel: {
    margin: '1px 0',
  },
  zIndex2: {
    zIndex: 2,
  },
  searchWrapper: {
    width: '50%',
    position: 'relative',
  },
  strongBoxShadow: {
    boxShadow: '3px 3px 8px 4px #ccc',
  },
  editServiceVehicle: {
    cursor: 'pointer',
    marginLeft: '5px',
    textDecoration: 'underline',
  },
  loopIcon: {
    verticalAlign: 'top',
    marginLeft: '3px',
  },
  warningIcon: {
    verticalAlign: 'middle',
    fontSize: '20px',
    color: '#D64747',
    margin: '0 18px 0 9px',
  },
  thumbnails: {
    width: 75,
    height: 75,
    marginRight: 10,
    borderRadius: '5%',
    objectFit: 'cover',
  },
}));

export default useStyles;
